export const ROUTES = {
  root: '/',
  faq: '/faq',
  signin: '/signin',
  signup: '/signup',
  downloadApp: '/download-app',
  info: '/info',
  signupSuccess: '/signup-success',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verifyEmail: '/verifyEmail',
  contacts: '/contacts',
  documentViewer: '/document-viewer',
  privacyPolicy: "/docs/user.pdf",
  personalDataPolicy: "/docs/pers.pdf",
  privacyPolicyDefault: '/docs/user.pdf',
  privacyPolicyIngos: '/docs/ingocare_user.pdf',
  personalDataPolicyDefault: '/docs/pers.pdf',
  personalDataPolicyIngos: '/docs/ingocare_policy.pdf',
  questionnaire: '/questionnaire',
  checkup: '/checkup',
  documents: '/documents',
  mobileApp: '/mobile-app',
  profile: {
    root: '/profile',
    security: '/profile/security',
    notifications: '/profile/notifications',
    support: '/profile/support',
  },

  myHealth: {
    root: '/my-health/',
    analysis: '/my-health/analysis',
    program: '/my-health/program',
    training: '/my-health/training',
    nutrition: '/my-health/nutrition',
    vitamins: '/my-health/vitamins',
    statistics: '/my-health/statistics',
    mentalHealth: '/my-health/mental-health',
    skinAnalysis: '/my-health/skin-analysis',
  },
  external: {
    telegram: 'https://telegram.org',
    vk: 'https://vk.com',
    dzen: 'https://dzen.ru',
    lab4u: 'https://lab4u.ru',
  },
} as const;
